export const PROFILE_VISIT_SITE = 'profile.visit-site';
